import { apiFetchWithRetry } from '@/lib/apiFetch';
import type { ComingUpEvent } from '@/types/registeredStudent';

interface FetchEventsParams {
  subject?: string | null;
  gradeBand?: string | null;
  curriculum?: string | null;
}

export async function fetchUpcomingEvents({ subject, gradeBand, curriculum }: FetchEventsParams = {}): Promise<ComingUpEvent[]> {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (gradeBand) params.set('gradeBand', gradeBand);
  if (curriculum) params.set('curriculum', curriculum);

  const qs = params.toString();
  const url = `/api/v1/events${qs ? `?${qs}` : ''}`;
  const res = await apiFetchWithRetry(url);
  if (!res.ok) return [];
  return res.json();
}
